import React, { Component } from 'react';
import './NowLiveScreen.scss';
import StationLogo from './StationLogo/StationLogo';
import NowLiveText from './NowLiveText/NowLiveText';
import NowLiveCover from './NowLiveCover/NowLiveCover';
import helpers from '../helpers';

/*
  Little trick to add stream delay

  Stream delay will always be a hard because it depends on many things,
  like what platform the listeners are on, what country they live in,
  what quality they listen to and what computer they are on. So this value
  is a best effort.
 */
const streamDelay = 30; // in seconds.

class NowLiveScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mainText: '',
            subText: '', // eslint-disable-line
            coverImage: '', // eslint-disable-line
            songPlaying: false
        };

        this.broadcast = {
            name: '',
            presenters: '',
            subtext: '',
            image: '',
            startdatetime: '',
            stopdatetime: '',
            broadcasters: ''
        };

        this.nowOnAir = {
            artist: '',
            title: '',
            image: '',
            startdatetime: '',
            enddatetime: ''
        };

        this.getTimer = untill => {
            let millisTill = false;

            if (untill instanceof Date && !Number.isNaN(untill)) {
                const now = new Date();
                millisTill = untill - now;
                if (millisTill < 0) {
                    millisTill = 2e3;
                }
            } else {
                throw new Error("getTimer didn't receive a valid Date object");
            }
            return millisTill;
        };
    }

    componentDidMount() {
        window.addEventListener('changeTheme', this.initializeData.bind(this));
        this.initializeData();
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutForNewBroadcast);
        clearTimeout(this.timeoutForNewNowOnAir);
        clearInterval(this.interval);
        clearInterval(this.intervalNowOnAir);
        window.removeEventListener(
            'changeTheme',
            this.initializeData.bind(this)
        );
    }

    initializeData() {
        this.setState({
            songPlaying: false
        });
        this.fetchBroadcast();
        this.fetchNowOnAir();
    }

    fetchBroadcast() {
        const channel = helpers.getMiniplayer(this).getTheme();
        if (this.timeoutForNewBroadcast)
            clearTimeout(this.timeoutForNewBroadcast);
        if (this.interval) clearInterval(this.interval);

        helpers.api.get('currentBroadcast', channel).then(
            response => {
                const bcName = response.title;
                const bcNameSplit = bcName.toLowerCase().indexOf(' - ');
                let subText = '';

                if (bcNameSplit >= 0) {
                    this.broadcast.name = bcName.substr(0, bcNameSplit);
                    subText += `${bcName.substr(bcNameSplit + 3)}\n`;
                } else {
                    this.broadcast.name = bcName;
                }

                if (response.presenters) {
                    this.broadcast.presenters = response.presenters;
                    subText += response.presenters;
                }

                if (response.broadcaster) {
                    this.broadcast.broadcasters = response.broadcaster;
                    this.broadcast.name += ` (${response.broadcaster})`;
                }

                if (response.startdatetime) {
                    const startdatetime = new Date(response.startdatetime);
                    const timeStart = `${startdatetime.getHours()}:${
                        startdatetime.getMinutes() === 0
                            ? '00'
                            : startdatetime.getMinutes()
                    }`;

                    this.broadcast.startdatetime = startdatetime;

                    subText += `\n${timeStart}`;
                }

                if (response.stopdatetime) {
                    const stopdatetime = new Date(response.stopdatetime);
                    const timeEnd = `${stopdatetime.getHours()}:${
                        stopdatetime.getMinutes() === 0
                            ? '00'
                            : stopdatetime.getMinutes()
                    }`;

                    this.broadcast.stopdatetime = stopdatetime;
                    subText += ` - ${timeEnd} uur`;

                    this.timeoutForNewBroadcast = setTimeout(
                        () => this.fetchBroadcast(),
                        this.getTimer(this.broadcast.stopdatetime)
                    );
                }

                this.broadcast.subtext = subText;

                if (response.image_url_200x200) {
                    this.broadcast.image = response.image_url_200x200;
                }

                const { songPlaying } = this.state;

                if (!songPlaying) {
                    if (response.image_url_200x200) {
                        this.setState({
                            coverImage: this.broadcast.image // eslint-disable-line
                        });
                    }
                    this.setState({
                        mainText: this.broadcast.name,
                        subText: this.broadcast.subtext // eslint-disable-line
                    });
                }
            },
            error => {
                throw new Error(error);
            }
        );

        // check every 5 minutes for new CurrentBroadcast
        this.interval = setInterval(() => this.fetchBroadcast(), 60e3 * 5);
    }

    fetchNowOnAir() {
        const channel = helpers.getMiniplayer(this).getTheme();
        if (this.timeoutForNewNowOnAir)
            clearTimeout(this.timeoutForNewNowOnAir);
        if (this.intervalNowOnAir) clearInterval(this.intervalNowOnAir);

        helpers.api.get('nowOnAir', channel).then(response => {
            const now = new Date();

            this.nowOnAir.startdatetime = new Date(response.startdatetime);
            this.nowOnAir.startdatetime.setSeconds(
                this.nowOnAir.startdatetime.getSeconds() + streamDelay
            );
            this.nowOnAir.enddatetime = new Date(response.enddatetime);
            this.nowOnAir.enddatetime.setSeconds(
                this.nowOnAir.enddatetime.getSeconds() + streamDelay
            );

            // Only show song if current playing
            if (
                this.nowOnAir.startdatetime - now <= 0 &&
                this.nowOnAir.enddatetime - now >= 0
            ) {
                this.nowOnAir.artist =
                    response.composer !== undefined &&
                    response.composer.length > 0
                        ? response.composer
                        : response.artist;
                this.nowOnAir.title = response.title;

                if (response.image_url_200x200) {
                    this.nowOnAir.image = response.image_url_200x200;

                    this.setState({
                        coverImage: this.nowOnAir.image // eslint-disable-line
                    });
                } else {
                    this.setState({
                        coverImage: this.broadcast.image // eslint-disable-line
                    });
                }

                this.timeoutForNewNowOnAir = setTimeout(
                    () => this.fetchNowOnAir(),
                    this.getTimer(this.nowOnAir.enddatetime)
                );

                this.setState({
                    mainText: this.nowOnAir.artist,
                    subText: this.nowOnAir.title, // eslint-disable-line
                    songPlaying: true
                });
            } else {
                const { name, subtext, image } = this.broadcast;
                const { mainText } = this.state;
                // If no song is playing, show broadcast name
                if (name === '') {
                    this.fetchBroadcast();
                } else if (mainText !== name) {
                    this.setState({
                        mainText: name,
                        subText: subtext, // eslint-disable-line
                        songPlaying: false
                    });

                    if (image) {
                        this.setState({
                            coverImage: image // eslint-disable-line
                        });
                    }
                }

                // check every 15s for new NowOnAir
                this.intervalNowOnAir = setInterval(
                    () => this.fetchNowOnAir(),
                    15e3
                );
            }
        });
    }

    render() {
        const { channel, theme } = this.props;
        return (
            <div className="NowLiveScreen">
                <StationLogo channel={channel} />
                <NowLiveText state={this.state} theme={theme} />
                <NowLiveCover state={this.state} />
            </div>
        );
    }
}

export default NowLiveScreen;
